export default __webpack_public_path__ + "static/Homepage-Graphic1-88ab92edccc27c3f962ad7847049016d.png";